import { render } from "./JobProblemDetails.vue?vue&type=template&id=104b8aea&scoped=true"
import script from "./JobProblemDetails.vue?vue&type=script&lang=js"
export * from "./JobProblemDetails.vue?vue&type=script&lang=js"

import "./JobProblemDetails.vue?vue&type=style&index=0&id=104b8aea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104b8aea"]])

export default __exports__